import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import { GroupManagement } from "@/pages/medewerkers/$userId/groepen/GroupManagement"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/groepen/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "planning"),
})

function RouteComponent() {
  const { data } = useCurrentUserSuspenseQuery()

  return <GroupManagement userId={Number(data.data.userId)} />
}
